import { RoomData } from '@/editor/data/room/Room';
import { RoomHighlightModel } from '@/editor/entities/2d/roomHighlightModel';
import { getPathFromEdges } from '@/editor/utils/edge';
import { dispersePath } from '@/editor/utils/shape';

export class RoomHighlightManager {
  private _roomHighlightedLineModel = new RoomHighlightModel();

  constructor() {}

  update(roomData: RoomData) {
    if (roomData) {
      this.clear();
      const path = dispersePath(getPathFromEdges(roomData.pathInfos));
      const holes = roomData.holeInfos.map((hole) => dispersePath(getPathFromEdges(hole)));
      this._roomHighlightedLineModel.update(path, holes);
    } else {
      this.clear();
    }
  }

  clear() {
    this._roomHighlightedLineModel.clear();
  }
}
